import type { DataAction } from 'client/js/redux/types/dataAction.type';

export const UPDATE_SINGLE_CREATION_DIALOG_OPEN_STATE = 'UPDATE_SINGLE_CREATION_DIALOG_OPEN_STATE' as const;
export const updateSingleCreationDialogOpenState = (open: boolean) => ({
  data: { open },
  type: UPDATE_SINGLE_CREATION_DIALOG_OPEN_STATE,
});
export type UpdateSingleCreationDialogOpenStateAction = DataAction<
  typeof UPDATE_SINGLE_CREATION_DIALOG_OPEN_STATE,
  { open: boolean }
>;

export const UPDATE_BULK_CREATION_DIALOG_OPEN_STATE = 'UPDATE_BULK_CREATION_DIALOG_OPEN_STATE' as const;
export const updateBulkCreationDialogOpenState = (open: boolean) => ({
  data: { open },
  type: UPDATE_BULK_CREATION_DIALOG_OPEN_STATE,
});
export type UpdateBulkCreationDialogOpenStateAction = DataAction<
  typeof UPDATE_BULK_CREATION_DIALOG_OPEN_STATE,
  { open: boolean }
>;

export const DISMISS_LINK_CREATION_DIALOG = 'DISMISS_LINK_CREATION_DIALOG' as const;
export const dismissLinkCreationDialog = () => ({ data: {}, type: DISMISS_LINK_CREATION_DIALOG });
export type DismissLinkCreationDialogAction = DataAction<typeof DISMISS_LINK_CREATION_DIALOG, {}>;

export type CreationDialogAction =
  | UpdateSingleCreationDialogOpenStateAction
  | UpdateBulkCreationDialogOpenStateAction
  | DismissLinkCreationDialogAction;
